import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ScheduledDate } from './schedule-date.model';
import * as fromScheduledDates from './schedule-date.reducer';
export const scheduledDatesState =
    createFeatureSelector<fromScheduledDates.State>(
        fromScheduledDates.scheduledDatesFeatureKey
    );

export const { selectIds, selectEntities, selectAll, selectTotal } =
    fromScheduledDates.adapter.getSelectors(scheduledDatesState);

export const selectScheduledDateType = (props: { ScheduledDateType: string }) =>
    createSelector(selectAll, (schedules: ScheduledDate[]) =>
        schedules.filter(x => x.ScheduledDateType === props.ScheduledDateType)
    );

export const selectMinFiscalYear = createSelector(selectAll, schedules =>
    schedules
        .filter(x => x.ScheduledDateType === 'FYE')
        .reduce(
            (a, c) =>
                new Date(Math.min(c.ScheduledEndDate.valueOf(), a.valueOf())),
            new Date()
        )
);
